import { render, staticRenderFns } from "./CultivationModuleRoot.vue?vue&type=template&id=4876fcfd&scoped=true&lang=html&"
import script from "./CultivationModuleRoot.vue?vue&type=script&lang=js&"
export * from "./CultivationModuleRoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4876fcfd",
  null
  
)

export default component.exports